<template>
  <div id="app" v-if="authIsChecked">
    <router-view
      v-if="$route.meta.isPublic"
    >
      <v-preloader v-show="loading" />
    </router-view>
    <layout-authorized
      v-else-if="authorised"
    />
    <login-form
      v-else
    />
    <!--    <router-view v-if="$route.meta.isPublic" />-->
    <!--    <template v-else-if="authorised">-->
    <!--      <main-header />-->
    <!--      <v-preloader v-show="loading" />-->
    <!--      <router-view />-->
    <!--    </template>-->
    <!--    <login-form v-else />-->
  </div>
</template>
<script>
import LoginForm from "@/components/LoginForm";
import LayoutAuthorized from "@/views/LayoutAuthorized";
import VPreloader from "@/components/VPreloader";
import { mapState, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    VPreloader,
    LoginForm,
    LayoutAuthorized
  },
  data() {
    return {
      // authIsChecked: false
    };
  },
  computed: {
    ...mapState(["isClient"]),
    ...mapGetters({
      authorised: "authorization/loggedIn",
      authIsChecked: "authorization/authIsChecked",
      user: "user/getUser",
      loading: "isLoading"
    })
  }
  // async created() {
  //   await this.$store.dispatch("authorization/checkAuth");
  //   this.authIsChecked = true;
  // }
};
</script>
